var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9148 6.81818H15.1477V13.5597C15.1477 14.2557 14.9837 14.8771 14.6555 15.424C14.3307 15.9676 13.8717 16.3968 13.2784 16.7116C12.6851 17.0232 11.9891 17.179 11.1903 17.179C10.3916 17.179 9.69555 17.0232 9.10227 16.7116C8.509 16.3968 8.0483 15.9676 7.72017 15.424C7.39536 14.8771 7.23295 14.2557 7.23295 13.5597V6.81818H8.46591V13.4602C8.46591 13.9574 8.57528 14.3999 8.79403 14.7876C9.01278 15.1721 9.32434 15.4754 9.72869 15.6974C10.1364 15.9162 10.6236 16.0256 11.1903 16.0256C11.7571 16.0256 12.2443 15.9162 12.652 15.6974C13.0597 15.4754 13.3712 15.1721 13.5866 14.7876C13.8054 14.3999 13.9148 13.9574 13.9148 13.4602V6.81818Z",
    fill: "#282828"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 11,
    height: 1,
    fill: "#282828"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.a94b6289699986d8f443af17814b5ee9.svg";
export { ForwardRef as ReactComponent };